export const C_PLATFORMS = {
  GOOGLE: 'google',
  APPLE: 'apple',
} as const;

export const C_ORIGIN = {
  SIGNUP: 'signup',
  SIGNIN: 'signin',
  TIME_OUT_ERROR: 'time-out-error',
  APIS_ERROR: 'apis-error',
  ADD_KID_FIRST_STEP: 'add_kid_first_step',
  ADD_KID_LAST_STEP: 'add_kid_last_step',
  ...C_PLATFORMS,
} as const;
